import styled from "styled-components";
import {getLineHeight, parseSize, transformSize} from "../../../common/generic-react.functions.js";
import {InputContainer, InputResetContainer} from "../../atoms/input/input.styles.js";
export const ColorPickerSampleContainer = styled.div.withConfig({
  displayName: "color-pickerstyles__ColorPickerSampleContainer",
  componentId: "sc-fsjpff-0"
})(["width:1rem;right:0;", ";", ""], ({
  color
}) => color && `background-color: ${color};`, {
  display: "flex",
  alignSelf: "auto",
  position: "absolute",
  height: "100%"
});
export const ColorPickerContainer = styled.div.withConfig({
  displayName: "color-pickerstyles__ColorPickerContainer",
  componentId: "sc-fsjpff-1"
})(["", " ", " input{", "}", "{", "}.input__error{font-size:", ";line-height:", ";", "}"], {
  display: "flex",
  alignItems: "center",
  position: "relative"
}, InputContainer, ({
  reset
}) => reset ? {
  paddingRight: "2.75rem"
} : {
  paddingRight: "1.25rem"
}, InputResetContainer, {
  right: "1.25rem"
}, ({
  size
}) => parseSize(transformSize(size, -1)), ({
  size
}) => getLineHeight(transformSize(size, -1)), {
  marginTop: "0.25rem",
  color: "var(--errorColor)"
});
export const ChromePickerContainer = styled.div.withConfig({
  displayName: "color-pickerstyles__ChromePickerContainer",
  componentId: "sc-fsjpff-2"
})(["height:250px;top:100%;", ""], {
  position: "absolute",
  backgroundColor: "rgba(0, 0, 0, 0)",
  zIndex: "50"
});
